import { returnApiUrl, returnSentryDsn, returnSentryEnvironment } from '../config/config'; 
import * as Sentry from "@sentry/react";

const apiUrl = returnApiUrl();

Sentry.init({
  dsn: returnSentryDsn(),
  integrations: [
    new Sentry.BrowserTracing({
      // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
      tracePropagationTargets: ["localhost", apiUrl],
    }),
    new Sentry.Replay(),
  ],
  environment: returnSentryEnvironment(),
  // Performance Monitoring
  tracesSampleRate: 1.0, // Capture 100% of the transactions, reduce in production!
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

export const captureAndFormatException = (error) => {
  // error = formatOpenAiErrorMessage(error);
  Sentry.captureException(error);
  // console.log('Captured sentry error.');
}

export default Sentry;